export default __webpack_public_path__ + "static/media/erro-indicativo-nascimento.bda61d51.png";